// extracted by mini-css-extract-plugin
export default {"button":"DangerButton_button__SYYVu"};